import { defineFcm } from '../shared/factory';

export const FCM_GROWTH_IS_STARTER = defineFcm('growth_is_starter').asBoolean().withDefault(false).toConfig({
	owner: 'squad-narwhal',
	scope: 'corgi-middle-end',
	context: 'growth_is_starter',
	description:
		'As a PM I want the ability to understand if a user has ever been a starter, is an active starter, has become a starter in last X days, and/or is an engaged starter in order to treat them with proper experience',
});
